import React from "react";
import { Helmet } from "react-helmet-async";
import "./aboutTeam.css";
import { managementMembersList } from "./aboutTeamMembers";

const AboutTeam = () => {
  // Create structured data for the team
  const teamStructuredData = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    name: "Bálint Analitika Laboratórium",
    employee: managementMembersList.map((member) => ({
      "@type": "Person",
      name: member.name,
      jobTitle: member.position,
      email: member.email,
      telephone: member.phone || "",
      image: member.picLink,
    })),
  };

  return (
    <>
      <Helmet>
        <title>
          Szakértői csapatunk | Bálint Analitika Laboratórium | Budapest XI.
          kerület
        </title>
        <meta
          name="description"
          content="Ismerje meg a Bálint Analitika laboratórium szakértői csapatát. Magasan képzett orvosok, laboratóriumi szakemberek és diagnosztikai szakértők csapata áll az Ön szolgálatában."
        />
        <meta
          name="keywords"
          content="Bálint Analitika szakértők, laboratóriumi szakemberek, orvosi diagnosztika Budapest, laboratóriumi team"
        />
        <script type="application/ld+json">
          {JSON.stringify(teamStructuredData)}
        </script>
      </Helmet>
      <main className="about-team navbar-margin">
        <div className="container">
          <header className="about-team-header">
            <h1 className="about-team-heading">Szakértői csapatunk</h1>
            <p className=" about-team-description">
              A Bálint Analitika csapata elhivatott szakértőkből áll, akik
              különböző diagnosztikai és elemzési területeken jártasak.
              <br />
              Szenvedéllyel és kiválóságra törekedve együtt dolgozunk az
              innovatív megoldásokon ügyfeleink számára. Ismerje meg tehetséges
              csapattagjainkat, akik elkötelezettek a legmagasabb színvonalú
              szolgáltatás és szakértelem nyújtása iránt munkánk minden
              területén.
              <br />
              Emellett büszkék vagyunk vezetőinkre is, akiknek széleskörű
              tapasztalata és irányítása hozzájárul vállalatunk sikeréhez.
              Vezetőségünk elkötelezett a növekedésünk és az ügyfeleink
              elégedettsége iránt, és mindig az új kihívásokkal való
              szembenézésre törekszik.
            </p>
          </header>
          <h2 className="visually-hidden">Munkatársaink bemutatása</h2>
          <div className="container about-team-grid-container">
            <div className="about-team-members-grid">
              {managementMembersList.map((member) => (
                <article
                  className="about-team-members-card medical-about-team-members-card-inner-grid"
                  key={member.id}
                >
                  <div
                    className="about-team-members-card-inner-grid medical-about-team-members-card-inner-grid"
                    key={member.id}
                  >
                    {/* ----- CARD PICTURE */}
                    <div className="about-team-members-img-container">
                      <img
                        src={member.picLink}
                        alt={member.name}
                        className="about-team-member-img"
                        loading="lazy"
                      />
                    </div>
                    {/* ----- CARD NAME */}
                    <div className="about-team-management-name-container">
                      <h3 className="about-team-member-name">{member.name}</h3>
                    </div>
                    {/* ----- CARD POSITION */}
                    <div className="about-team-management-position-container">
                      <p className="about-team-member-position">
                        {member.position}
                      </p>
                    </div>
                    {/* ----- CARD CONTACT */}
                    <address className="about-team-management-contact-container">
                      <a
                        href={`mailto:${member.email}`}
                        className="about-team-member-contact"
                        aria-label={`Email küldése ${member.name} részére: ${member.email}`}
                      >
                        {member.email}
                      </a>
                      {member.id === 4 && (
                        <div className="about-team-management-contact-container">
                          <a
                            href={`tel:${member.phone.replace(/\s/g, "")}`}
                            className="about-team-member-position"
                            aria-label={`${member.name} telefonszáma: ${member.phone}`}
                          >
                            {member.phone}
                          </a>
                        </div>
                      )}
                    </address>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default AboutTeam;
